<script setup>
import { computed, ref } from 'vue';
import { useI18n } from 'vue-i18n';
import Dialog from 'dashboard/components-next/dialog/Dialog.vue';

const { t } = useI18n();
const dialogRef = ref(null);

const section = (title, body, example = '') => ({ title, body, example });

const sections = computed(() => [
  section(
    t('INBOX_MGMT.RECONTACT.HELP.SECTIONS.WHAT.TITLE'),
    t('INBOX_MGMT.RECONTACT.HELP.SECTIONS.WHAT.BODY'),
    t('INBOX_MGMT.RECONTACT.HELP.SECTIONS.WHAT.EXAMPLE')
  ),
  section(
    t('INBOX_MGMT.RECONTACT.HELP.SECTIONS.WHEN.TITLE'),
    t('INBOX_MGMT.RECONTACT.HELP.SECTIONS.WHEN.BODY'),
    t('INBOX_MGMT.RECONTACT.HELP.SECTIONS.WHEN.EXAMPLE')
  ),
  section(
    t('INBOX_MGMT.RECONTACT.HELP.SECTIONS.WHO.TITLE'),
    t('INBOX_MGMT.RECONTACT.HELP.SECTIONS.WHO.BODY'),
    t('INBOX_MGMT.RECONTACT.HELP.SECTIONS.WHO.EXAMPLE')
  ),
  section(
    t('INBOX_MGMT.RECONTACT.HELP.SECTIONS.ALWAYS.TITLE'),
    t('INBOX_MGMT.RECONTACT.HELP.SECTIONS.ALWAYS.BODY')
  ),
  section(
    t('INBOX_MGMT.RECONTACT.HELP.SECTIONS.AFTER.TITLE'),
    t('INBOX_MGMT.RECONTACT.HELP.SECTIONS.AFTER.BODY'),
    t('INBOX_MGMT.RECONTACT.HELP.SECTIONS.AFTER.EXAMPLE')
  ),
]);

const open = () => dialogRef.value?.open();
</script>

<template>
  <button
    type="button"
    class="shrink-0 text-sm font-medium text-n-slate-11 underline decoration-n-slate-8 underline-offset-4 transition-colors hover:text-n-slate-12"
    @click="open"
  >
    {{ t('INBOX_MGMT.RECONTACT.HELP.LINK') }}
  </button>
  <Dialog
    ref="dialogRef"
    type="edit"
    width="2xl"
    overflow-y-auto
    :title="t('INBOX_MGMT.RECONTACT.HELP.TITLE')"
    :description="t('INBOX_MGMT.RECONTACT.HELP.INTRO')"
    :show-confirm-button="false"
    :cancel-button-label="t('INBOX_MGMT.RECONTACT.FORM.CANCEL')"
  >
    <div class="flex max-h-[65vh] flex-col gap-3 overflow-y-auto pe-1">
      <article
        v-for="item in sections"
        :key="item.title"
        class="rounded-xl border border-n-weak bg-n-solid-1 px-4 py-3"
      >
        <h3 class="text-sm font-medium text-n-slate-12">
          {{ item.title }}
        </h3>
        <p
          class="mt-2 mb-0 whitespace-pre-line text-sm leading-6 text-n-slate-11"
        >
          {{ item.body }}
        </p>
        <p
          v-if="item.example"
          class="mt-3 mb-0 rounded-lg bg-n-alpha-2 px-3 py-2 text-sm leading-6 text-n-slate-12"
        >
          <span class="font-medium">{{
            t('INBOX_MGMT.RECONTACT.HELP.EXAMPLE')
          }}</span>
          {{ item.example }}
        </p>
      </article>
    </div>
  </Dialog>
</template>
